import DiveList from './DiveList';

export default DiveList;
